import ApiManager from './ApiManager'

export default class ActivityManager {
    static async getTicketPriceForSimpleTicketType(
        prestation,
        startTime,
        space = null,
        durationId = null,
        nbTickets = 1,
        establishment = null
    ) {
        // let prestationPriceGroup = prestation.prestation_price_group[0]
        // let prestationPrice = prestation.price
        // let prestationPriceHT = prestation.price_ht
        // let prestationTVA = prestation.price - prestation.price_ht

        // let ticketPrice = prestationPrice
        // let ticketPriceHT = prestationPriceHT
        // let ticketTVA = prestationTVA

        // let prestStartTime = moment.unix(startTime / 1000).format('HH:mm:ss')

        // // dd(prestationPriceGroup.slot1_start_time);
        // if (prestationPriceGroup.slot1_start_time && prestationPriceGroup.slot1_end_time) {
        //     let slot1StartTime = moment(prestationPriceGroup.slot1_start_time, 'HH:mm:ss').format('HH:mm:ss')
        //     let slot1EndTime = moment(prestationPriceGroup.slot1_end_time, 'HH:mm:ss').format('HH:mm:ss')
        //     if (prestStartTime >= slot1StartTime && prestStartTime <= slot1EndTime) {
        //         ticketPrice = prestationPriceGroup.slot1_price
        //         ticketPriceHT = prestationPriceGroup.slot1_price_ht
        //         ticketTVA = prestationPriceGroup.slot1_price - prestationPriceGroup.slot1_price_ht
        //     }
        // }
        // if (prestationPriceGroup.slot2_start_time && prestationPriceGroup.slot2_end_time) {
        //     let slot2StartTime = moment(prestationPriceGroup.slot2_start_time, 'HH:mm:ss').format('HH:mm:ss')
        //     let slot2EndTime = moment(prestationPriceGroup.slot2_end_time, 'HH:mm:ss').format('HH:mm:ss')
        //     if (prestStartTime >= slot2StartTime && prestStartTime <= slot2EndTime) {
        //         ticketPrice = prestationPriceGroup.slot2_price
        //         ticketPriceHT = prestationPriceGroup.slot2_price_ht
        //         ticketTVA = prestationPriceGroup.slot2_price - prestationPriceGroup.slot2_price_ht
        //     }
        // }
        // if (prestationPriceGroup.slot3_start_time && prestationPriceGroup.slot3_end_time) {
        //     let slot3StartTime = moment(prestationPriceGroup.slot3_start_time, 'HH:mm:ss').format('HH:mm:ss')
        //     let slot3EndTime = moment(prestationPriceGroup.slot3_end_time, 'HH:mm:ss').format('HH:mm:ss')
        //     if (prestStartTime >= slot3StartTime && prestStartTime <= slot3EndTime) {
        //         ticketPrice = prestationPriceGroup.slot3_price
        //         ticketPriceHT = prestationPriceGroup.slot3_price_ht
        //         ticketTVA = prestationPriceGroup.slot3_price - prestationPriceGroup.slot3_price_ht
        //     }
        // }

        // // ticketPrice = (prestationPrice + space.price ?? 0) / space.capacity;
        // // ticketPriceHT = (prestationPriceHT + space.price ?? 0) / space.capacity;
        // // ticketTVA = ticketPrice - ticketPriceHT;
        let priceDetatils = await ApiManager.getActivityPriceDetails(prestation.id, space.id, startTime, durationId, nbTickets)
        return { price: priceDetatils.byTicket.price, priceHT: priceDetatils.byTicket.priceHT, tva: priceDetatils.byTicket.tva }
    }

    static getPercentage(current, total) {
        if (total == 0) return 100
        let per = (current / total) * 100
        return per.toFixed(2)
    }
    static getTicketNbr(booking, prestation_id) {
        if (!booking.just_order?.items) return undefined
        let nb = booking.just_order.items.find((item) => {
            return item.item_type == 'App\\Models\\Prestation\\Prestation' && item.item_id == prestation_id
        })
        return nb?.nb_contributor
    }
    static getTotalCMDDetails(event) {
        let getTotalCMDDetails = {
            currentPrice: 0,
            totalPrice: 0,
            currentTicketsNbr: 0,
            totalTicketsNbr: 0,
        }
        if (event && event.bookings) {
            let currentPrice = 0
            let totalPrice = 0
            let currentTicketsNbr = 0
            let totalTicketsNbr = 0
            let totalRemise = 0
            event.bookings.forEach((booking) => {
                currentPrice += booking.just_order?.current_price ?? 0
                totalPrice += booking.just_order?.total_price ?? 0
                totalRemise += booking.just_order?.remise_price ?? 0
                currentTicketsNbr += this.getTicketNbr(booking, event.data?.prestation?.id) ?? 0
            })
            currentTicketsNbr = event.data?.info?.nb_contributor ?? currentTicketsNbr
            totalTicketsNbr =
                this.getPrestationTypeSlug(event.data?.prestation) == 'events'
                    ? event.data?.prestation?.type
                    : Math.min(event.data?.info?.space?.capacity ?? 0, event.data?.prestation?.max_contributors ?? 0)
            getTotalCMDDetails = {
                currentPrice: currentPrice.toFixed(2),
                totalPrice: totalPrice.toFixed(2),
                currentTicketsNbr: currentTicketsNbr,
                totalTicketsNbr: totalTicketsNbr,
                totalRemise: totalRemise.toFixed(2),
            }
        }
        return getTotalCMDDetails
    }

    static async getAvailableEventPlaces(event, startDate) {
        try {
            const places = await ApiManager.getAvailableEventPlaces(event, startDate)
            return places.data.availablePlaces
        } catch (error) {
            console.error(error)
            return null
        }
    }
    static getPrestationTypeSlug(prestation) {
        return prestation.subCategory?.slug?.toLowerCase()
    }
}
